module.exports = __webpack_public_path__ + "img/arrows-fullscreen.73e3f20f.svg";